module.exports = __webpack_public_path__ + "static/media/capa.509d94d0.jpg";